
  const MapNonClickablekpis = [
    {
      name: "Total Batteries Connected",
      nameKey: "kpi_header.total_connected_batteries",
    },
  ];
  export { MapNonClickablekpis};
  